import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { MediaTypeSettingsPage as Component } from './MediaTypeSettingsPage'
import { AppStateType } from '../../reducers'
import { selectMediaType } from '../../selectors/mediaTypes'
import { selectActiveModal } from '../../selectors/modal'
import { selectAreaWritable } from '../../selectors/auth'
import { AREA_CONSTANTS } from '../../services/auth'

const mapStateToProps = (state: AppStateType) => ({
  mediaType: selectMediaType(state),
  activeModal: selectActiveModal(state),
  editable: selectAreaWritable(state, { area: AREA_CONSTANTS.SETTINGS_MEDIA_TYPE }),
})

export const MediaTypeSettingsPage = withRouter(connect(mapStateToProps)(Component))
